import mixitup from 'mixitup';

const mixitupContainer = document.querySelector('.room-overview');

if (mixitupContainer) {
    var mixer = mixitup(mixitupContainer, {
        load: {
            filter: 'all',
        },
        selectors: {
            target: '.room-teaser',
        },
        animation: {
            easing: 'ease-in-out',
        },
    });
}
